export function PlaySvg() {
  return (
    <svg
      className="tp-svg--play"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <path
        d="M1 1L16.5556 11L1 21V1Z"
        fill="#010F1C"
        stroke="#161613"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VideoPlayerSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M12 7.00012L0 0.0719185L0 13.9283L12 7.00012Z"
        fill="currentColor"
      />
    </svg>
  );
}
